const GET_BANNERS = "GET_BANNERS";
const GET_BANNERS_SUCCESS = "GET_BANNERS_SUCCESS";
const GET_BANNERS_FAILURE = "GET_BANNERS_FAILURE";
const CLEAR_GET_BANNERS = "CLEAR_GET_BANNERS";

const bannerSymbols = {
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAILURE,
  GET_BANNERS,
  CLEAR_GET_BANNERS,
};
export default bannerSymbols;
